import dualPlayer from './module/dual-player';

window.pixelsDualInject = dualPlayer({
  playlistDeliveryCap: 1,
  contextualDeliveryCap: 1,
  playlist: __ENV_MODE__ === 'prod' ? '8ee88370-58eb-4d8d-862b-23a372d20880' : '1fd90aa2-8816-4906-8acf-69288d7c1e05',
  midArticlePlaylist: null,
  organisation: 'atrtennis',
  mockedSection: 'has_top_match',
  mockedMidArticleSection: 'has_mid_playlist',
  useOutstreamForHero: true,
  adTagUrlPromise: Promise.resolve(null),
  requireContextualForOutstream: true
});
